export default "__VITE_ASSET__DLaNf0ny__"